export const DirectoryIcon =(props)=> {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.IconStyleClass}
      style={{
        verticalAlign: "middle",
        marginRight: "0.5rem",
      }}
      fill="currentColor"
      overflow="hidden"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="#DEB538"
        d="M102.4 198.776l84.33-120.47h451.764l84.33 120.47H102.4z"
      ></path>
      <path
        fill="#FFD658"
        d="M120.47 198.776h783.06c66.258 0 120.47 54.212 120.47 120.471V801.13c0 66.26-54.212 120.471-120.47 120.471H120.47C54.213 921.6 0 867.388 0 801.13V319.246c0-66.259 54.212-120.47 120.47-120.47z"
      ></path>
    </svg>
  );
};

export const DirectoryIcon2 =(props)=> {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      
      className={props.IconStyleClass}
      viewBox="0 0 1024 1024"
    >
      <path
        fill="#FFA000"
        d="M853.333 256h-384L384 170.667H170.667c-46.934 0-85.334 38.4-85.334 85.333v170.667h853.334v-85.334c0-46.933-38.4-85.333-85.334-85.333z"
      ></path>
      <path
        fill="#FFCA28"
        d="M853.333 256H170.667c-46.934 0-85.334 38.4-85.334 85.333V768c0 46.933 38.4 85.333 85.334 85.333h682.666c46.934 0 85.334-38.4 85.334-85.333V341.333c0-46.933-38.4-85.333-85.334-85.333z"
      ></path>
    </svg>
  )
}

export const DirectoryIconGrayStyle =(props)=> {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1024 1024" 
      className={props.IconStyleClass}
      version="1.1">
      <path 
        d="M853.333333 256H469.333333l-85.333333-85.333333H170.666667c-46.933333 0-85.333333 38.4-85.333334 85.333333v170.666667h853.333334v-85.333334c0-46.933333-38.4-85.333333-85.333334-85.333333z" 
        fill="#343a40"
      ></path>
      <path 
        d="M853.333333 256H170.666667c-46.933333 0-85.333333 38.4-85.333334 85.333333v426.666667c0 46.933333 38.4 85.333333 85.333334 85.333333h682.666666c46.933333 0 85.333333-38.4 85.333334-85.333333V341.333333c0-46.933333-38.4-85.333333-85.333334-85.333333z" 
        fill="#adb5bd"
      ></path>
    </svg>
  )
}

export const JpgIcon =(props)=> {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    className={props.IconStyleClass}
    style={{ verticalAlign: "middle", marginRight: "0.5rem", }}
    version="1.1"
    viewBox="0 0 270.933 270.933"
    xmlSpace="preserve"
  >
    <g fill="currentColor" transform="matrix(.2576 0 0 .24546 3.572 9.79)">
      <path
        fill="#ebecf0"
        d="M901.85 926.476a48.762 48.762 0 01-48.761 48.762H170.423a48.762 48.762 0 01-48.762-48.762V48.763A48.762 48.762 0 01170.423 0h418.864a48.762 48.762 0 0134.621 14.14L887.71 277.945a48.762 48.762 0 0114.14 34.62z"
      ></path>
      <path
        fill="#c1c7d0"
        d="M901.85 926.476v48.762A48.762 48.762 0 01853.09 1024H170.423a48.762 48.762 0 01-48.762-48.762v-48.762a48.762 48.762 0 0048.762 48.762h682.666a48.762 48.762 0 0048.762-48.762z"
      ></path>
      <path
        fill="#ffab00"
        d="M24.137 536.381h975.237v243.81a48.762 48.762 0 01-48.762 48.762H72.9a48.762 48.762 0 01-48.762-48.762z"
      ></path>
      <path
        fill="#ff8b00"
        d="M121.66 536.381v-97.523L24.138 536.38zm780.19 0l.976-97.523 97.036 97.523z"
      ></path>
      <path
        fill="#fff"
        d="M770.681 750.934a120.442 120.442 0 01-78.506 29.257 93.623 93.623 0 01-97.524-97.524 97.524 97.524 0 0197.524-97.524A101.912 101.912 0 01764.83 610.5l-20.968 24.869a74.118 74.118 0 00-52.663-19.992 63.878 63.878 0 00-62.415 67.291 62.903 62.903 0 0063.878 67.779 77.044 77.044 0 0045.349-14.141v-35.108H703.39a7.314 7.314 0 01-7.314-7.315v-14.628a7.314 7.314 0 017.314-7.315h59.49a7.314 7.314 0 017.314 7.315zm-235.52-97.524c0-22.43-16.091-34.133-40.472-34.133h-39.01v67.779h38.522c24.869-.488 40.473-14.141 40.473-34.621zm33.646 0a66.316 66.316 0 01-75.58 64.853H455.68v53.638a7.314 7.314 0 01-7.315 7.314h-18.53a7.314 7.314 0 01-7.313-7.314V595.383a7.314 7.314 0 017.314-7.314h67.291a63.39 63.39 0 0171.68 63.39zM377.173 712.9a59.49 59.49 0 01-63.39 67.29 71.192 71.192 0 01-60.465-30.232l21.943-22.43a48.762 48.762 0 0038.034 21.943c17.554 0 29.745-11.703 29.745-37.06V595.384a7.314 7.314 0 017.314-7.314h19.505a7.314 7.314 0 017.314 7.314z"
      ></path>
      <path
        fill="#c1c7d0"
        d="M901.85 312.564v6.827H638.05a48.762 48.762 0 01-48.762-48.762V.001a48.762 48.762 0 0134.621 14.14l264.29 263.803a48.762 48.762 0 0113.653 34.62z"
      ></path>
    </g>
  </svg>
   
  );
}

export const Mp4Icon =(props)=> {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.IconStyleClass}
      style={{ verticalAlign: "middle", marginRight: "0.5rem", }}
      fill="currentColor"
      overflow="hidden"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="#EBECF0"
        d="M901.632 926.72c0 12.8-5.12 25.088-14.336 34.304-9.216 9.216-21.504 14.336-34.304 14.336H170.496c-12.8 0-25.6-5.12-34.304-14.336-9.216-9.216-14.336-21.504-14.336-34.304V48.64c0-12.8 5.12-25.6 14.336-34.304C144.896 5.12 157.696 0 170.496 0h418.816c12.8 0 25.6 5.12 34.816 14.336l263.68 263.68c9.216 9.216 14.336 21.504 14.336 34.816V926.72z"
      ></path>
      <path
        fill="#C1C7D0"
        d="M901.632 926.72v48.64c0 12.8-5.12 25.6-14.336 34.304-9.216 9.216-21.504 14.336-34.304 14.336H170.496c-27.136 0-48.64-22.016-48.64-48.64v-48.64c0 12.8 5.12 25.088 14.336 34.304 9.216 9.216 21.504 14.336 34.304 14.336h682.496c27.136 0 48.64-22.016 48.64-48.64z"
      ></path>
      <path
        fill="#0092D3"
        d="M24.064 536.576h975.36v243.712c0 27.136-22.016 48.64-48.64 48.64H73.216c-12.8 0-25.6-5.12-34.304-14.336-9.216-9.216-14.336-21.504-14.336-34.816v-243.2z"
      ></path>
      <path
        fill="#007199"
        d="M121.856 536.576v-97.792l-97.792 97.792h97.792zm779.776 0l1.024-97.792 97.28 97.792h-98.304z"
      ></path>
      <path
        fill="#C1C7D0"
        d="M901.632 312.832v6.656h-263.68c-27.136 0-48.64-22.016-48.64-48.64V0c12.8 0 25.6 5.12 34.816 14.336l264.192 263.68c8.704 9.216 13.824 21.504 13.312 34.816z"
      ></path>
      <path
        fill="#FFF"
        d="M278.016 769.536h-56.32V580.608h75.264l33.792 118.272 32.768-118.272h75.264v188.928h-55.808V711.68L384 681.984l3.072-33.792h-1.024l-33.792 121.344h-43.008l-34.816-121.344 2.048 27.648 2.048 29.696v64zm252.928 0h-61.44V580.608h90.624c52.736.512 79.872 22.016 81.408 63.488-.512 44.032-27.136 66.048-79.36 66.56h-30.72v58.88zm0-102.912h25.6c16.384 0 24.576-7.68 24.576-22.528 0-12.8-10.752-19.456-32.768-19.456h-17.408v41.984zm118.272 63.488v-43.008l87.552-102.912h50.176v105.984h23.552v39.936h-23.552v38.912h-51.2v-38.912h-86.528zm86.528-96.256l-44.032 56.32h44.032v-56.32z"
      ></path>
    </svg>
  );
}

export const PngIcon =(props)=> {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.IconStyleClass}
      style={{ verticalAlign: "middle", marginRight: "0.5rem", }}
      fill="currentColor"
      overflow="hidden"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="#C1C7D0"
        d="M901.85 926.476v48.762A48.762 48.762 0 01853.09 1024H170.423a48.762 48.762 0 01-48.762-48.762v-48.762a48.762 48.762 0 0048.762 48.762h682.666a48.762 48.762 0 0048.762-48.762z"
      ></path>
      <path
        fill="#EBECF0"
        d="M901.85 926.476a48.762 48.762 0 01-48.761 48.762H170.423a48.762 48.762 0 01-48.762-48.762V48.763A48.762 48.762 0 01170.423 0h418.864a48.762 48.762 0 0134.621 14.14L887.71 277.945a48.762 48.762 0 0114.14 34.62v613.912z"
      ></path>
      <path
        fill="#5E6C84"
        d="M24.137 536.381h975.237v243.81a48.762 48.762 0 01-48.762 48.762H72.9a48.762 48.762 0 01-48.762-48.762V536.38z"
      ></path>
      <path
        fill="#172B4D"
        d="M121.66 536.381v-97.523L24.138 536.38h97.524zm780.19 0l.976-97.523 97.036 97.523H901.85z"
      ></path>
      <path
        fill="#FFF"
        d="M792.624 752.884a120.442 120.442 0 01-78.507 29.257 93.623 93.623 0 01-97.523-97.524 97.524 97.524 0 0197.523-97.523 101.912 101.912 0 0172.656 25.356l-20.968 24.868a74.118 74.118 0 00-52.663-19.992 63.878 63.878 0 00-62.415 65.341 62.903 62.903 0 0063.878 67.779 77.044 77.044 0 0045.349-14.141v-35.109H719.48a7.802 7.802 0 01-7.802-7.801v-10.728a7.802 7.802 0 017.802-7.802h65.341a7.802 7.802 0 017.802 7.802zm-249.173-32.183V598.31a7.802 7.802 0 017.802-7.802h17.066a7.802 7.802 0 017.802 7.802v173.105a7.802 7.802 0 01-7.802 7.801h-16.09a7.802 7.802 0 01-6.34-2.925L443.977 645.12v126.294a7.802 7.802 0 01-7.802 7.801h-17.067a7.802 7.802 0 01-7.802-7.801V598.309a7.802 7.802 0 017.802-7.802h19.505a7.802 7.802 0 016.339 2.926zm-199.436-65.828c0-22.43-16.091-34.134-40.472-34.134h-39.01v67.78h38.522c25.356 0 40.96-13.654 40.96-33.646zm33.646 0a66.316 66.316 0 01-75.581 63.878h-37.547v52.663a7.802 7.802 0 01-7.802 7.801h-17.554a7.802 7.802 0 01-7.802-7.801V598.309a7.802 7.802 0 017.802-7.802h66.804a63.39 63.39 0 0171.68 63.39z"
      ></path>
      <path
        fill="#C1C7D0"
        d="M901.85 313.052v6.827H638.05a48.762 48.762 0 01-48.762-48.762V0a48.762 48.762 0 0134.621 14.629l264.29 263.801a48.762 48.762 0 0113.653 34.621z"
      ></path>
    </svg>
  );
}

export const YmlIcon =(props)=> {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.IconStyleClass}
      style={{ verticalAlign: "middle", marginRight: "0.5rem" }}
      fill="currentColor"
      overflow="hidden"
      viewBox="0 0 1024 1024"
    >
      <path d="M354.401 0c-87.04 0-157.44 70.559-157.44 157.599V433.28H78.72c-21.658 0-39.363 17.7-39.363 39.363V708.96c0 21.658 17.7 39.358 39.363 39.358h118.241V866.4c0 87.04 70.4 157.599 157.44 157.599H827.04c87.04 0 157.598-70.559 157.598-157.599V315.034c0-41.749-38.988-81.93-107.52-149.28L848 136.633l-29.123-29.112C751.54 38.989 711.393 0 669.6 0H354.406zm0 78.72h287.202c28.354 7.091 27.996 42.138 27.996 76.8v120.161c0 21.658 17.7 39.358 39.362 39.358H827.04c39.388 0 78.878-.026 78.878 39.362v512c0 43.32-35.553 78.879-78.878 78.879H354.406c-43.325 0-78.72-35.558-78.72-78.879V748.32h393.918c21.663 0 39.362-17.695 39.362-39.358V472.643c0-21.663-17.7-39.363-39.362-39.363H275.68V157.599c0-43.32 35.395-78.879 78.72-78.879zm-213.12 428.641h23.998l40.32 89.278 41.282-89.278h23.998l-53.76 107.52v68.158H195.04v-67.2l-53.76-108.478zm153.6 0h32.64l49.92 143.038h.958L427.36 507.36h33.598V683.04h-22.073V576.48c0-10.88.318-26.562.958-47.042h-.958l-52.802 153.6h-19.2l-52.798-153.6h-.962c1.28 22.4 1.92 38.722 1.92 48.962V683.04h-20.158V507.36zm214.078 0h22.082v155.52h69.12v20.158H508.96V507.36z"></path>
    </svg>
  );
}


export const FileIcon = (props) => {
  console.log(props)
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.IconStyleClass}
      style={{ verticalAlign: "middle" }}
      fill="currentColor"
      overflow="hidden"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="#EAEAEA"
        d="M640 0H128a64 64 0 00-64 64v896a64 64 0 0064 64h768a64 64 0 0064-64V320L640 0z"
      ></path>
      <path fill="#434854" d="M640 0v256a64 64 0 0064 64h256L640 0z"></path>
      <path d="M704 320l256 256V320zM224 256h256a32 32 0 100-64H224a32 32 0 100 64zm0 128h256a32 32 0 100-64H224a32 32 0 100 64zm0 128h576a32 32 0 100-64H224a32 32 0 100 64zm576 64H224a32 32 0 100 64h576a32 32 0 100-64zm0 128H224a32 32 0 100 64h576a32 32 0 100-64zm0 128H224a32 32 0 100 64h576a32 32 0 100-64z"></path>
    </svg>
  );
}


export const WebMIcon =(props)=> {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.IconStyleClass}
      style={{ verticalAlign: "middle" }}
      fill="currentColor"
      overflow="hidden"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="#FFDCEE"
        d="M0 686.081a332.799 332.799 0 10665.598 0 332.799 332.799 0 10-665.598 0z"
      ></path>
      <path
        fill="#434260"
        d="M883.197 1024H243.2a141.056 141.056 0 01-140.8-140.8V140.803A141.056 141.056 0 01243.2.003h516.35a89.088 89.088 0 0163.233 25.6l189.695 189.695a38.4 38.4 0 0111.52 27.904V883.2a141.056 141.056 0 01-140.8 140.8zM243.2 76.803a64 64 0 00-64 64V883.2a64 64 0 0064 64h639.998a64 64 0 0064-64V259.074l-179.2-179.2a12.8 12.8 0 00-8.447-3.071z"
      ></path>
      <path
        fill="#434260"
        d="M209.663 417.794h30.72l17.664 98.048 9.984 60.415c4.096-20.224 8.448-40.448 12.8-60.415l26.368-98.048h25.6l25.6 98.048c4.352 19.711 8.448 39.935 12.8 60.415 3.072-20.48 6.4-40.704 9.472-60.415l17.92-98.048h28.416l-37.12 188.415h-37.12l-25.6-104.703a995.77 995.77 0 01-8.704-43.264c-2.56 14.336-5.632 28.416-8.704 43.264l-25.6 104.703h-35.84zm242.432 0h111.103v25.6h-81.407v51.2h69.12v25.6h-69.12v60.927h84.48v25.6H452.094zm139.775 0h58.368c38.656 0 66.56 12.288 66.56 46.336a41.728 41.728 0 01-25.6 40.704v1.28a43.264 43.264 0 0137.12 44.8c0 37.375-30.464 55.295-72.192 55.295H591.87zm55.04 78.592c28.672 0 40.704-10.752 40.704-28.416s-13.312-27.136-39.936-27.136h-25.6v55.552zm4.608 86.527c29.44 0 46.336-10.496 46.336-33.536s-16.384-30.463-46.336-30.463h-29.952v64zm97.28-165.12h34.048l34.56 94.209c4.352 12.543 8.192 25.6 12.544 38.143 4.351-12.8 7.935-25.6 12.287-38.143l34.048-95.232h34.304v188.415h-26.624v-93.183c0-16.896 2.304-41.216 3.84-58.368l-15.104 43.52L838.91 588.8h-18.431l-33.024-89.855-14.848-43.52c0 17.152 3.584 41.472 3.584 58.368v93.183h-25.6z"
      ></path>
    </svg>
  );
}

export const ZipIcon =(props)=> {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.IconStyleClass}
      style={{ verticalAlign: "middle" }}
      version="1.1"
      viewBox="0 0 56 56"
      xmlSpace="preserve"
    >
      <path
        fill="#E9E9E0"
        d="M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0036.985 0z"
      ></path>
      <path fill="#D9D7CA" d="M37.5 0.151L37.5 12 49.349 12z"></path>
      <path
        fill="#e59500"
        d="M48.037 56H7.963A1.463 1.463 0 016.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z"
      ></path>
      <g fill="#FFF">
        <path d="M25.266 42.924v1.326l-4.799 7.205-.273.219h5.072V53h-6.699v-1.326l4.799-7.205.287-.219h-5.086v-1.326h6.699zM29.271 53h-1.668V42.924h1.668V53zM33.414 53h-1.641V42.924h2.898c.428 0 .852.068 1.271.205.419.137.795.342 1.128.615.333.273.602.604.807.991s.308.822.308 1.306c0 .511-.087.973-.26 1.388a2.9 2.9 0 01-.725 1.046c-.31.282-.684.501-1.121.656s-.921.232-1.449.232h-1.217V53zm0-8.832v3.992h1.504c.2 0 .398-.034.595-.103.196-.068.376-.18.54-.335s.296-.371.396-.649c.1-.278.15-.622.15-1.032 0-.164-.023-.354-.068-.567a1.637 1.637 0 00-.28-.615 1.657 1.657 0 00-.595-.492c-.255-.132-.593-.198-1.012-.198h-1.23z"></path>
      </g>
      <g fill="#C8BDB8">
        <path d="M28.5 24v-2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h2V8h-2V6h-2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-4v5c0 2.757 2.243 5 5 5s5-2.243 5-5v-5h-4zm2 5c0 1.654-1.346 3-3 3s-3-1.346-3-3v-3h6v3z"></path>
        <path d="M26.5 30h2a1 1 0 100-2h-2a1 1 0 100 2z"></path>
      </g>
    </svg>
  )
}

export const S3Icon =(props)=> {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="svg-icon-backend-type"
      viewBox="0 0 256 256"
    >
      <g
        strokeMiterlimit="10"
        fontFamily="none"
        fontSize="none"
        fontWeight="none"
        textAnchor="none"
      >
        <g
          fill="#171537"
          style={{ mixBlendMode: "normal" }}
          transform="matrix(.8 0 0 .8 25.6 25.6)"
        >
          <path d="M-32 288V-32h320v320z"></path>
        </g>
        <path
          fill="#ff8f00"
          d="M42 11l5.691-2L42 7l-5.691 2zm1 1.667V19l5-1.667V11zm-2 0L36 11v6.333L41 19zM28 11l5.691-2L28 7l-5.691 2zm1 1.667V19l5-1.667V11zm-2 0L22 11v6.333L27 19zM21 23l5.691-2L21 19l-5.691 2zm1 1.667V31l5-1.667V23zm-2 0L15 23v6.333L20 31zM7 23l5.691-2L7 19l-5.691 2zm1 1.667V31l5-1.667V23zm-2 0L1 23v6.333L6 31zM14 35l5.691-2L14 31l-5.691 2zm1 1.667V43l5-1.667V35zm-2 0L8 35v6.333L13 43z"
          transform="matrix(.8 0 0 .8 25.6 25.6) scale(5.33333)"
        ></path>
      </g>
    </svg>
  );
}

export const SharePointIcon =(props)=> {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="svg-icon-backend-type"
      viewBox="0 0 48 48"
      fill="#f00"
    >
      <path fill="#13504f" d="M23 4a12 12 0 100 24 12 12 0 100-24z"></path>
      <path
        fill="#13a3a9"
        d="M33.5 16a10.5 10.5 0 100 21 10.5 10.5 0 100-21z"
      ></path>
      <path fill="#1ddaea" d="M24 28a8 8 0 100 16 8 8 0 100-16z"></path>
      <path
        fill="#027178"
        d="M22.319 34H5.681A1.682 1.682 0 014 32.319V15.681C4 14.753 4.753 14 5.681 14h16.638c.928 0 1.681.753 1.681 1.681v16.638c0 .928-.753 1.681-1.681 1.681z"
      ></path>
      <path
        fill="#fff"
        d="M10.432 28.75v-2.298c.426.349 2.391 1.048 2.9 1.048.299 0 2.138.088 2.138-1.041 0-1.633-5.082-1.494-5.082-4.725 0-.536.066-3.059 4.133-3.059 1.041 0 2.271.261 2.628.395v2.147c-.176-.12-.89-.718-2.496-.718-1.877 0-2.04.883-2.04 1.041 0 1.359 4.998 1.544 4.998 4.711 0 3.172-3.614 3.074-4.177 3.074-.577 0-2.62-.383-3.002-.575z"
      ></path>
    </svg>
  );
}

export const LocalServer = 'data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkxheWVyIDEiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0yNzguMjYgNzIuNzNjMC0xNi4wOC00MC44Mi0zOS40Ni0xMDQuNzctMzkuNDZTNjguNyA1Ni42NSA2OC43IDcyLjczYzAgMTQuMTcgMzEuNjkgMzQgODIuOTIgMzguNDlDMTc4Ljg1IDkwIDIyNC4wNiA3NS43IDI3OC4yNCA3Mi44MmMwLS4wMy4wMi0uMDYuMDItLjA5Wk02OC43IDI2OC42MWMwIDExLjM4IDIwLjQ5IDI2LjM2IDU1LjA3IDM0LjE4di0zOC4zNkMxMDEuNiAyNjAuMDkgODIuNjYgMjUzIDY4LjcgMjQzLjY5Wk02OC43IDE0OC4xOWM3Ljg0IDExLjExIDI3Ljg4IDIxLjYzIDU1LjA3IDI3Ljcxdi0xNmE1MC42MSA1MC42MSAwIDAgMSA1LTIxLjMzYy0yNC00LjA4LTQ0LjY0LTExLjQtNjAuMDYtMjEuMVpNNjguNyAyMTMuNDhjNy44NCAxMS4xMSAyNy44OCAyMS42MyA1NS4wNyAyNy43MXYtNDIuMDVjLTIyLjE3LTQuMzMtNDEuMTEtMTEuNDctNTUuMDctMjAuNzRaTTE1My44NSAyOTIuMTh2NTQuMzljMTQuMzIgMjUuMDggNjkuNzEgNDguODYgMTQ0LjczIDQ4Ljg2UzQyOSAzNzEuNjUgNDQzLjMgMzQ2LjU3di01NC4zOWMtMzAgMjMuNDQtODMgMzguNzYtMTQ0LjcyIDM4Ljc2cy0xMTQuNy0xNS4zMi0xNDQuNzMtMzguNzZaIiBmaWxsPSIjMGQxYjJhIiBjbGFzcz0iZmlsbC0wMDAwMDAiPjwvcGF0aD48cGF0aCBkPSJNMTUzLjg1IDM3OS4yNHY0MS44N2MwIDI3LjIgNjEuOSA1Ny42MiAxNDQuNzMgNTcuNjJzMTQ0LjcyLTMwLjQyIDE0NC43Mi01Ny42MnYtNDEuODdjLTMwIDIzLjQzLTgzIDM4Ljc1LTE0NC43MiAzOC43NXMtMTE0LjctMTUuMzItMTQ0LjczLTM4Ljc1Wk0xNTkuODYgMTQ0LjljLTMuODkgNS02IDEwLjA2LTYgMTUgMCAyNy4yIDYxLjkgNTcuNjIgMTQ0LjczIDU3LjYyczE0NC43MS0zMC4zOCAxNDQuNzEtNTcuNTgtNjEuODktNTcuNjItMTQ0LjcyLTU3LjYyYy02Ny42OCAwLTEyMS4zNCAyMC4zMS0xMzguNzIgNDIuNThaIiBmaWxsPSIjMGQxYjJhIiBjbGFzcz0iZmlsbC0wMDAwMDAiPjwvcGF0aD48cGF0aCBkPSJNMTUzLjg1IDIxMC4zN3Y0OS4xNWMxNC4zMiAyNS4wOCA2OS43MSA0OC44NiAxNDQuNzMgNDguODZTNDI5IDI4NC42IDQ0My4zIDI1OS41MnYtNDkuMTVjLTMwLjkxIDIyLjgzLTgzLjEgMzcuMjctMTQ0LjcyIDM3LjI3cy0xMTMuODItMTQuNDQtMTQ0LjczLTM3LjI3WiIgZmlsbD0iIzBkMWIyYSIgY2xhc3M9ImZpbGwtMDAwMDAwIj48L3BhdGg+PC9zdmc+'


export const CollectionIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="800"
      height="800"
      viewBox="0 0 36 36"
      className="svg-icon-backend-type"
    >
      <path
        d="M30.14 3a1 1 0 00-1-1h-22a1 1 0 00-1 1v1h24z"
        className="clr-i-solid clr-i-solid-path-1"
      ></path>
      <path
        d="M32.12 7a1 1 0 00-1-1h-26a1 1 0 00-1 1v1h28z"
        className="clr-i-solid clr-i-solid-path-2"
      ></path>
      <path
        d="M32.12 10H3.88A1.88 1.88 0 002 11.88v18.24A1.88 1.88 0 003.88 32h28.24A1.88 1.88 0 0034 30.12V11.88A1.88 1.88 0 0032.12 10zM8.56 13.45a3 3 0 11-3 3 3 3 0 013-3zM30 28H6l7.46-7.47a.71.71 0 011 0l3.68 3.68L23.21 19a.71.71 0 011 0L30 24.79z"
        className="clr-i-solid clr-i-solid-path-3"
      ></path>
      <path fill="none" d="M0 0H36V36H0z"></path>
    </svg>
  );
}


export const PlayButtonIcon = (props) => {
  return(
    <svg
    className="me-1"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="#fcfcfc"
    version="1.1"
    viewBox="0 0 408.221 408.221"
    xmlSpace="preserve"
    >
      <path d="M204.11 0C91.388 0 0 91.388 0 204.111c0 112.725 91.388 204.11 204.11 204.11 112.729 0 204.11-91.385 204.11-204.11C408.221 91.388 316.839 0 204.11 0zm82.437 229.971l-126.368 72.471c-17.003 9.75-30.781 1.763-30.781-17.834V140.012c0-19.602 13.777-27.575 30.781-17.827l126.368 72.466c17.004 9.752 17.004 25.566 0 35.32z"></path>
    </svg>
  )
}

export const AnnotateIcon = (props)=>{
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="me-1"
      width="18"
      height="18"
      fill="#fcfcfc"
      viewBox="0 0 1920 1920"
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path d="M1468.235 113v99.388l-112.94 112.941v-99.388H112.94v1468.235h1242.353v-438.211l112.941-112.941v664.094H0V113h1468.235zM421.271 1163.353c96-9.035 154.729 108.423 190.87 197.647 28.235 68.894 38.4 92.612 72.283 96 33.882 3.388 89.223-58.73 112.94-101.647 16.53-26.51 51.42-34.6 77.93-18.07 26.51 16.529 34.6 51.42 18.07 77.929-9.035 16.94-92.611 160.376-205.552 160.376h-9.036c-70.023-4.517-121.976-48.564-169.411-166.023-47.436-117.46-77.93-127.624-77.93-127.624a484.518 484.518 0 00-97.13 225.883c-6.549 31.187-37.14 51.16-68.329 44.611-31.187-6.55-51.16-37.141-44.611-68.33 20.33-94.87 79.059-310.587 199.906-320.752zm256.376-485.647v112.941H338.824V677.706h338.823zM903.53 451.824v112.94H338.824v-112.94h564.705z"></path>
        <path d="M1903.059 468.765l-225.883-225.883a56.47 56.47 0 00-80.188 0L919.341 920.53a56.476 56.476 0 00-15.813 39.53v282.353h282.354a56.47 56.47 0 0039.53-16.941l677.647-677.647c21.523-21.959 21.523-57.101 0-79.06zm-740.894 660.706H1016.47V983.776l451.764-451.764 145.694 145.694-451.764 451.765zm531.953-531.953l-145.694-145.694 89.223-89.224 145.694 145.694-89.223 89.224z"></path>
      </g>
    </svg>
  );
}
export const NeuralNetworkSvg = (props) => {
  return (
    <svg id="a" className={`custom-menu-icon ${props.className ?? ''}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 292.02 289.25" fill="currentColor"><circle cx="142.65" cy="39.4" r="22.15" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="3" /><circle cx="142.65" cy="39.4" r="36.4" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /><circle cx="142.65" cy="144.63" r="22.15" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="3" /><circle cx="142.65" cy="144.63" r="36.4" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /><circle cx="252.63" cy="144.63" r="22.15" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="3" /><circle cx="252.63" cy="144.63" r="36.4" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /><circle cx="142.65" cy="249.86" r="22.15" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="3" /><circle cx="142.65" cy="249.86" r="36.4" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /><circle cx="39.4" cy="39.4" r="22.15" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="3" /><circle cx="39.4" cy="39.4" r="36.4" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /><circle cx="39.4" cy="144.63" r="22.15" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="3" /><circle cx="39.4" cy="144.63" r="36.4" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /><circle cx="39.4" cy="249.86" r="22.15" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="3" /><circle cx="39.4" cy="249.86" r="36.4" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /><line x1="173.37" y1="61.15" x2="226.38" y2="119.31" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /><line x1="66.76" y1="166.19" x2="119.77" y2="224.34" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /><line x1="67.35" y1="61.15" x2="119.36" y2="118.31" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /><line x1="76.85" y1="143.84" x2="105.73" y2="143.84" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /><line x1="180.49" y1="143.84" x2="214.38" y2="143.84" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /><line x1="67.35" y1="224.54" x2="119.36" y2="169.39" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /><path d="M104.54,249.46h-27.3,27.3Z" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /><line x1="67.35" y1="119.31" x2="119.36" y2="65.16" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /><line x1="170.8" y1="223.76" x2="224.81" y2="170.61" fill="currentColor" stroke="currentColor" stroke-miterlimit="10" stroke-width="6" /></svg>
  );
};
export const MenuCollectionIcon = (props) => {
  return (
    <svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 36 36"
  className="svg-icon-backend-menu"
  fill="currentColor"
>
  <path d="M30.14 3a1 1 0 00-1-1h-22a1 1 0 00-1 1v1h24z" />
  <path d="M32.12 7a1 1 0 00-1-1h-26a1 1 0 00-1 1v1h28z" />
  <path d="M32.12 10H3.88A1.88 1.88 0 002 11.88v18.24A1.88 1.88 0 003.88 32h28.24A1.88 1.88 0 0034 30.12V11.88A1.88 1.88 0 0032.12 10zM8.56 13.45a3 3 0 11-3 3 3 3 0 013-3zM30 28H6l7.46-7.47a.71.71 0 011 0l3.68 3.68L23.21 19a.71.71 0 011 0L30 24.79z" />
</svg>

  );
}

export const LogOutIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-power"><path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path><line x1="12" y1="2" x2="12" y2="12"></line></svg>
  );
}

export const SettingsIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-settings"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
  );
}

export const SubscriptionIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-star"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
  );
}

export const ProfileIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
  );
}

// export const LogOutIcon = (props) => {
//   return (
//     <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-power"><path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path><line x1="12" y1="2" x2="12" y2="12"></line></svg>
//   );
// }